import React, { useEffect, useState, useRef } from 'react'
import '../../App.css';
import Swal from 'sweetalert2';
import { auth, db } from '../../firebase';
import { collection, addDoc, Timestamp, query, orderBy, onSnapshot, getDoc, getDocs, deleteDoc, doc, setDoc, where, limit, updateDoc, getCountFromServer } from 'firebase/firestore'

export default function Labourdetails() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });
    const [userData, setUserData] = useState();
    const [staffcats, setstaffcats] = useState([]);
    const [searchText, setsearchText] = useState("");
    const [staffdetails, setstaffdetails] = useState([]);
    const [staffcatid, setstaffcatid] = useState("");
    const [staffname, setstaffname] = useState("");
    const [mobileno, setmobileno] = useState("");
    const [payment, setpayment] = useState(0);
    const [address, setaddress] = useState("");

    const [updocid, setupdocid] = useState("");
    const [upstaffcatid, setupstaffcatid] = useState("");
    const [upstaffname, setupstaffname] = useState("");
    const [upaddress, setupaddress] = useState("");
    const [upmobileno, setupmobileno] = useState("");
    const [uppayment, setuppayment] = useState(0);


    useEffect(() => {
        if (searchText === '') {
            fetchData1()
        } else {
            fetchData2()
        }
    }, [searchText]);



    useEffect(() => {
        auth.onAuthStateChanged((user) => {
            setUserData(user);
        });
    });

    const fetchData1 = async () => {
        try {
            // Fetch staff Categorys in real-time
            const staffcatsQuery = query(collection(db, 'staffcats'), orderBy("createdAt", "asc"));
            onSnapshot(staffcatsQuery, (staffcatsSnapshot) => {
                setstaffcats(staffcatsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data()
                })));
            });

            // Fetch Staff details and staff Categorys in real-time
            const staffdetailsQuery = query(collection(db, 'staffdetails'), orderBy("staffname", "asc"));
            onSnapshot(staffdetailsQuery, async (staffdetailsSnapshot) => {
                const staffdetails = staffdetailsSnapshot.docs.map(doc => ({
                    id: doc.id,
                    data: doc.data(),
                    staffcatid: doc.data().staffcatid
                }));

                // Collect all staffcatids for batch fetching
                const staffcatids = [...new Set(staffdetails.map(detail => detail.staffcatid))];

                // Fetch all staffcats in parallel using Promise.all
                const docRefs = staffcatids.map(id => doc(db, "staffcats", id));
                const docSnaps = await Promise.all(docRefs.map(docRef => getDoc(docRef)));

                // Create a map of staffcatid to staffcat name for fast lookup
                const staffcatMap = {};
                docSnaps.forEach((docSnap, index) => {
                    if (docSnap.exists()) {
                        staffcatMap[staffcatids[index]] = docSnap.data().staffcat;
                    }
                });

                // Combine Staff details with staffcat data
                const combinedData = staffdetails.map(detail => ({
                    id: detail.id,
                    data: detail.data,
                    staffcat: staffcatMap[detail.staffcatid] || ""
                }));

                setstaffdetails(combinedData);
            });

        } catch (error) {
            Toast.fire({
                icon: "error",
                title: error.message
            });
            console.error(error.message);
        }
    };


    const fetchData2 = async () => {
        try {
            const filteredData = staffdetails.filter((item) => {
                const roomNumber = String(item.data.staffname).toUpperCase();
                return roomNumber.includes(searchText.toUpperCase());
            });

            setstaffdetails(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }


    const handleSubmit = async () => {
        if (!staffname || !staffcatid) {
            Toast.fire({
                icon: "error",
                title: 'Please fill all the fields!!'
            });
            return;
        }

        await addDoc(collection(db, 'staffdetails'), {
            staffcatid: staffcatid,
            staffname: staffname,
            address: address,
            payment: parseFloat(payment),
            mobileno: mobileno,
            uid: userData.uid,
            created: Timestamp.now()
        });

        setstaffname("");
        setaddress("");
        setmobileno("");
        Toast.fire({
            icon: "success",
            title: 'Staff Details Added Successfully!!'
        });
    }

    const handleDelete = async (docid, staffcatid) => {
        const taskDocRef = doc(db, 'staffdetails', docid)
        await deleteDoc(taskDocRef);

        const q = query(collection(db, 'staffdetails'), where('staffcatid', '==', staffcatid));
        const snapshot = await getCountFromServer(q);

        await updateDoc(doc(db, "staffcats", staffcatid), {
            noofrooms: snapshot.data().count,
        });


        Toast.fire({
            icon: "success",
            title: 'Staff Details Deleted Successfully!!'
        });
        fetchData1();
    }

    const handleEdit = (id, staffcatid, staffname, address, accupancy, mobileno) => {
        setupdocid(id);
        setupstaffname(staffname);
        setupstaffcatid(staffcatid);
        setupaddress(address);
        setuppayment(accupancy);
        setupmobileno(mobileno);
    }


    const handleUpdate = async () => {
        if (!upstaffname || !upstaffname) {
            Toast.fire({
                icon: "error",
                title: 'Please fill all the fields!!'
            });
            return;
        }

        try {

            await setDoc(doc(db, "staffdetails", updocid), {
                staffcatid: upstaffcatid,
                staffname: upstaffname,
                address: upaddress,
                payment: uppayment,
                mobileno: upmobileno,
                uid: userData.uid,
                created: Timestamp.now()
            });

            Toast.fire({
                icon: "success",
                title: 'Staff Details Updated Successfully!!'
            });

            fetchData1();
        } catch (error) {
            console.log(error.message);
        }

    }


    return (
        <div>
            <div className="content-wrapper">
                <br />
                <section className="content">
                    <div className="container-fluid">
                        <button className="btn btn-secondary " style={{ float: "right" }} >|| Staff Details ||</button>
                        <button className="btn btn-info btn-sm" data-toggle="modal" data-target="#insert-modal">Add Staff Details</button><br /><br />
                        <div className="card card-primary card-outline ex1">
                            <div className=" p-1">
                                &nbsp;&nbsp;<input type="search" value={searchText} onChange={(e) => setsearchText(e.target.value)}
                                    className='form-control col-sm-4' placeholder='Type here......' />&nbsp;
                            </div>
                            <div className="card-body table-responsive p-0" >
                                <table className="table table-bordered table-hover table-striped table-head-fixed">
                                    <thead>
                                        <tr>
                                            <th>Sr No</th>
                                            <th>Staff Category</th>
                                            <th>Staff Name</th>
                                            <th>Mobile No</th>
                                            <th>Address</th>
                                            <th>Payment</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            staffdetails.map((item, num = 1) =>
                                                <tr key={num + 1}>
                                                    <td width="80">{num + 1}</td>
                                                    <td>{item.staffcat} </td>
                                                    <td>{item.data.staffname}</td>
                                                    <td>{item.data.mobileno}</td>
                                                    <td>{item.data.address} </td>
                                                    <td>{item.data.payment}</td>
                                                    <td>
                                                        <a onClick={() => handleEdit(item.id, item.data.staffcatid, item.data.staffname, item.data.address, item.data.payment, item.data.mobileno, item.data.mobileno)} href='#0' data-toggle="modal" data-target="#text-modal1" className="btn btn-sm btn-success" > <i className="fa fa-edit"></i></a>&nbsp;
                                                        <a onClick={() => { if (window.confirm('Are u sure?')) { handleDelete(item.id, item.data.staffcatid) }; }} className="btn btn-sm btn-danger" href='#0' > <i className="fa fa-trash"></i></a>&nbsp;
                                                    </td>
                                                </tr>
                                            )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </section>
            </div>

            {/* ============================================= modal start ================================================= */}

            <div className="modal fade" id="insert-modal">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Add Staff Details</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <label>Staff Category</label>
                                    <select value={staffcatid} onChange={(e) => setstaffcatid(e.target.value)} className="form-control" >
                                        <option value=""></option>
                                        {
                                            staffcats.map((item, index) =>
                                                <option key={index} value={item.id}>{item.data.staffcat}</option>
                                            )
                                        }
                                    </select>
                                </div>
                                <div className="col-sm-6">
                                    <label>  Staff Name</label>
                                    <input type="text" value={staffname} onChange={(e) => setstaffname(e.target.value)} className="form-control" />
                                </div>
                                <div className="col-sm-6 mt-2">
                                    <label>  Mobile No </label>
                                    <input type="text" value={mobileno} onChange={(e) => setmobileno(e.target.value)} className="form-control" />
                                </div>
                                <div className="col-sm-6 mt-2">
                                    <label>  Address</label>
                                    <input type="text" value={address} onChange={(e) => setaddress(e.target.value)} className="form-control" />
                                </div>
                                <div className="col-sm-6 mt-2">
                                    <label> Payment</label>
                                    <input type="number" value={payment} onChange={(e) => setpayment(e.target.value)} className="form-control" />
                                </div>

                            </div>
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="submit" onClick={() => handleSubmit()} className="btn btn-primary" >Save </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>


            <div className="modal fade" id="text-modal1">
                <div className="modal-dialog modal-xl">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Edit Staff Details</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <label>Staff Category</label>
                                    <select value={upstaffcatid} onChange={(e) => setupstaffcatid(e.target.value)} className="form-control" >
                                        <option value=""></option>
                                        {
                                            staffcats.map((item, index) =>
                                                <option key={index} value={item.id}>{item.data.staffcat}</option>
                                            )
                                        }
                                    </select>
                                </div>
                                <div className="col-sm-6">
                                    <label>  Staff Name</label>
                                    <input type="text" value={upstaffname} onChange={(e) => setupstaffname(e.target.value)} className="form-control" />
                                </div>

                                <div className="col-sm-6 mt-2">
                                    <label>  Mobile No</label>
                                    <input type="text" value={upmobileno} onChange={(e) => setupmobileno(e.target.value)} className="form-control" />
                                </div>
                                <div className="col-sm-6 mt-2">
                                    <label>  Address</label>
                                    <input type="text" value={upaddress} onChange={(e) => setupaddress(e.target.value)} className="form-control" />
                                </div>
                                <div className="col-sm-6 mt-2">
                                    <label> Payment</label>
                                    <input type="number" value={uppayment} onChange={(e) => setuppayment(e.target.value)} className="form-control" />
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer justify-content-between">
                            <button type="button" onClick={() => handleUpdate()} className="btn btn-primary" data-dismiss="modal">Update </button>
                            <button type="button" className="btn btn-danger" data-dismiss="modal">Close</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
